<template lang="pug">
  .shop-by-carousel-card
    .product-wrap
      .inner-wrap
        .inner-top
          p.bold.text-color-1.text-center.xs-f-xmedium.max-at-tweak.xs-mb-10m {{ product?.name.split('-')[0] }}
          p.text-color-3.text-center.xs-f-xsmall.max-at-tweak {{ product?.short_description }}

        img(:src="productToneSwatch?.url" :alt="productToneSwatch?.alt_text")

        .btn-wrap
          Button.mirror.mr-btn.btn-block.xs-f-xxsmall.max-at-tweak(@click="$emit('open-playground-modal', product)")
            MrIcon.camera-icon(name="mirror" height="1.5em" :fill="false")
            | &nbsp; Virtually Try It On

          Button.mr-btn.btn-secondary.btn-block.mt-10.xs-f-xxsmall.max-at-tweak(@click="$emit('open-purchase-panel', product)") Add To Bag
</template>

<script>
  import MrIcon from '@components/MrIcon';
  export default {
    name: "ShopByCarouselCard",

    emits: ['open-playground-modal', 'open-purchase-panel'],
    components: {
      MrIcon
    },
    props: {
      product: {
        type: Object,
        required: true
      }
    },

    computed: {
      productToneSwatch() {
        return this.product?.imagery?.toneSwatch;
      }
    }
  };
</script>

<style scoped lang="stylus">
  .shop-by-carousel-card
    width 15em
    .product-wrap
      display flex
      flex-direction column
      align-items center
      justify-content center
      padding 2em 1em
      box-shadow 0 2px 4px 0 rgba(0, 0, 0, 0.08)
      border-radius 5px
      margin 1em 0
      width 14.5em
      height 25em
      background-color ui-color-3
      color #000

      .inner-wrap
        padding 1em 0.5em
        display flex
        flex-direction column
        align-items center
        justify-content center

        .inner-top
          min-height 25%

        img
          width 150px
          height 150px
          margin 0.5em
          margin-bottom 1em
          border 1px solid #000
          border-radius 50%

    @media mq-tablet-plus
      .product-wrap
        width 16em

</style>